import React, {useContext} from "react";
import {ApiUtility} from "../common/ApiUtility";
import {MessageDisplayerUtility} from "../common/MessageDisplayerUtility";
import {GlobalContext} from "./AdminFrame";
import {usePagePathSegment} from "../common/hooks/usePagePathSegment";
import {Constants} from "../common/Constants";

export let AdminHeader = function () {
    const context = useContext(GlobalContext);
    const pagePathSegment = usePagePathSegment();
    let pageLabel;

    for (const routeKey in Constants.routes) {
        const route = Constants.routes[routeKey];
        if (route.pathSegment === pagePathSegment) {
            pageLabel = route.label;
            break;
        }
    }

    function logout(event: React.SyntheticEvent) {
        if (event) {
            event.preventDefault();
        }

        ApiUtility.logout()
            .then(function () {
                context.navigator.navigateTo('/login');
            })
            .catch(function (err) {
                console && console.error(err);
                MessageDisplayerUtility.error('An error occurred while logging out.');
                context.navigator.navigateTo('/login');
            });
    }

    return (
        <div className="admin-header">
            <div className="admin-header-content">
                <div className="admin-header-page-title-section">
                    <div className="admin-header-page-title">
                        {pageLabel || ''}
                    </div>
                </div>
                <div className="admin-header-account-info-container">
                    <img
                        className="admin-header-account-icon"
                        src="/static/images/users-icon-light-gray.svg"
                    />
                    <div
                        className="admin-header-username-display"
                    >{document.querySelector('.logged-in-user-name')?.textContent}</div>
                    <div className="admin-header-username-separator">|</div>
                    <div className="logout-option-container">
                        <div
                            className="logout-option"
                            onClick={logout}
                        >Sign Out
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
